// Rendu commun des états d'une requête : chargement (squelette), erreur (message, cause,
// réessai), route non encore livrée (lot en attente de fusion), droits insuffisants.
import { EtatErreur, EtatVide, Squelette } from '@eec/ui';
import { Construction, Lock } from 'lucide-react';
import type { ReactNode } from 'react';
import { ErreurApi, messageErreur } from '../api/erreurs';

export interface ProprietesEtatRequete {
  chargement: boolean;
  erreur: unknown;
  onReessayer?: () => void;
  /** Lot qui livre la route, pour l'état « non disponible » (par exemple « L0-C »). */
  lot?: string;
  fonction?: string;
  lignes?: number;
  children: ReactNode;
}

export function EtatRequete({ chargement, erreur, onReessayer, lot, fonction = 'Cette fonction', lignes = 4, children }: ProprietesEtatRequete) {
  if (chargement) return <Squelette lignes={lignes} />;
  if (erreur) return <AffichageErreur erreur={erreur} onReessayer={onReessayer} lot={lot} fonction={fonction} />;
  return <>{children}</>;
}

export function AffichageErreur({ erreur, onReessayer, lot, fonction = 'Cette fonction' }: { erreur: unknown; onReessayer?: () => void; lot?: string; fonction?: string }) {
  if (erreur instanceof ErreurApi && erreur.routeIndisponible) {
    return (
      <EtatVide titre={`${fonction} n'est pas encore disponible`} icone={Construction}>
        <p>
          Le serveur déployé n&apos;expose pas encore ce service{lot ? ` (livré par le lot ${lot})` : ''}. Aucune donnée n&apos;est affichée tant
          qu&apos;il n&apos;est pas en place.
        </p>
      </EtatVide>
    );
  }
  if (erreur instanceof ErreurApi && erreur.statut === 403) {
    return (
      <EtatVide titre="Accès non autorisé" icone={Lock}>
        <p>{erreur.message}. Demandez à l&apos;administrateur local de votre organisation si vous en avez besoin.</p>
      </EtatVide>
    );
  }
  return (
    <EtatErreur
      message={messageErreur(erreur)}
      cause={erreur instanceof ErreurApi ? `${erreur.code}${erreur.statut ? ` (HTTP ${erreur.statut})` : ''}` : null}
      onReessayer={onReessayer}
    />
  );
}
